import { Components, Theme } from '@mui/material';

const ChipTheme: Components['MuiChip'] = {
  styleOverrides: {
    root: (props) => {
      const theme = props.theme as Theme;

      return {
        backgroundColor: theme.palette.neutral.surface,
        color: theme.palette.neutral.primary,
        '&:hover': {
          backgroundColor: theme.palette.overlay.dark4
        }
      };
    }
  }
};
export default ChipTheme;
